const getBaseDashAppPageUrl = (companyId: string, productId: string) =>
  `/dashApp?companyId=${encodeURIComponent(companyId)}&productId=${encodeURIComponent(productId)}`;

export default {
  getBaseDashAppPageUrl,
};
